<template>
  <div>
    <main class="content">
      <div v-if="event">
        <h3>Schlussveranstaltung bearbeiten</h3>
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{name: routeName, params: $route.params}"
              exact
            >Generelle Texte</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{name: routeName + '-results' , params: $route.params}"
              exact
            >Resultate</router-link>
          </li>
        </ul>
        <div class="tab-content">
          <router-view class="tab-pane fade show active" entity="event" :data="event"/>
        </div>
      </div>
      <loading v-else></loading>
    </main>
  </div>
</template>
<script>
export default {
  props: ["event", "routeName"]
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/event/Edit.vue